"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GamesStaticHttpAdapter = void 0;
var lodash_1 = require("lodash");
var HttpAdapter_1 = require("./HttpAdapter");
var Utility_1 = require("./Utility");
var GamesStaticHttpAdapter = /** @class */ (function (_super) {
    __extends(GamesStaticHttpAdapter, _super);
    function GamesStaticHttpAdapter(options) {
        return _super.call(this, options) || this;
    }
    GamesStaticHttpAdapter.prototype.getEndpoint = function () {
        switch (this.options.environment) {
            case 'production':
                return 'https://games-static.7platform.net';
            default:
                return 'https://dev.games-static.7platform.net';
        }
    };
    GamesStaticHttpAdapter.prototype.getResponse = function (ui) {
        return __awaiter(this, void 0, void 0, function () {
            var getConfig, data, newConfigUrl, oldConfigUrl, defaultConfigUrlV2, companyOverrideV2, defaultConfigV2, configUrl;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        getConfig = function (url) { return __awaiter(_this, void 0, void 0, function () {
                            var response, error_1;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        return [4 /*yield*/, this.httpLibrary.get(url)];
                                    case 1:
                                        response = _a.sent();
                                        return [2 /*return*/, response.data];
                                    case 2:
                                        error_1 = _a.sent();
                                        return [2 /*return*/, null];
                                    case 3: return [2 /*return*/];
                                }
                            });
                        }); };
                        if (!(0, Utility_1.isUuid)(ui)) return [3 /*break*/, 6];
                        newConfigUrl = "".concat(this.getEndpoint(), "/ui-config/").concat(ui, ".json");
                        oldConfigUrl = "".concat(this.getEndpoint(), "/ui/").concat(ui, ".json");
                        defaultConfigUrlV2 = "".concat(this.getEndpoint(), "/ui-config/defaultConfig.json");
                        return [4 /*yield*/, getConfig(newConfigUrl)];
                    case 1:
                        companyOverrideV2 = _a.sent();
                        if (!companyOverrideV2) return [3 /*break*/, 3];
                        return [4 /*yield*/, (getConfig(defaultConfigUrlV2))];
                    case 2:
                        defaultConfigV2 = _a.sent();
                        data = this.mergeOverrideWithDefaultConfig(defaultConfigV2, companyOverrideV2);
                        return [3 /*break*/, 5];
                    case 3:
                        console.warn('New config is not defined for this company, getting old config file...');
                        return [4 /*yield*/, getConfig(oldConfigUrl)];
                    case 4:
                        data = _a.sent();
                        if (!data) {
                            console.error('There is no v1 config for this company');
                            return [2 /*return*/, {
                                    name: ui,
                                    data: {}
                                }];
                        }
                        _a.label = 5;
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        configUrl = "".concat(this.getEndpoint(), "/colors/").concat(ui, ".json");
                        return [4 /*yield*/, getConfig(configUrl)];
                    case 7:
                        data = _a.sent();
                        _a.label = 8;
                    case 8: return [2 /*return*/, __assign({ name: ui }, data)];
                }
            });
        });
    };
    GamesStaticHttpAdapter.prototype.parseOption = function (option) {
        return (0, lodash_1.includes)(option, ',') ? option.split(',') : option;
    };
    GamesStaticHttpAdapter.prototype.getConfiguration = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, uiOption, promises, responses, config, baseColor, theme, colors, promises, responses, response;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        result = {};
                        if (!this.options.ui) return [3 /*break*/, 7];
                        uiOption = this.parseOption(this.options.ui);
                        if (!(0, lodash_1.isArray)(uiOption)) return [3 /*break*/, 2];
                        promises = (0, lodash_1.map)(uiOption, function (ui) { return _this.getResponse(ui); });
                        return [4 /*yield*/, Promise.all(promises)];
                    case 1:
                        responses = _a.sent();
                        responses.forEach(function (response) {
                            result[response.name] = (0, lodash_1.omit)(response, 'name');
                        });
                        return [3 /*break*/, 7];
                    case 2:
                        if (!(0, Utility_1.isUuid)(uiOption)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.getResponse(uiOption)];
                    case 3:
                        config = _a.sent();
                        config.name = 'config';
                        baseColor = config.baseColor, theme = config.theme;
                        colors = [baseColor, theme];
                        promises = (0, lodash_1.map)(colors, function (color) { return _this.getResponse(color); });
                        return [4 /*yield*/, Promise.all(promises)];
                    case 4:
                        responses = _a.sent();
                        result[config.name] = (0, lodash_1.omit)(config, 'name');
                        responses.forEach(function (response) {
                            result[response.name] = (0, lodash_1.omit)(response, 'name');
                        });
                        return [3 /*break*/, 7];
                    case 5: return [4 /*yield*/, this.getResponse(uiOption)];
                    case 6:
                        response = _a.sent();
                        result[response.name] = (0, lodash_1.omit)(response, 'name');
                        _a.label = 7;
                    case 7: return [2 /*return*/, {
                            ui: __assign({}, result),
                        }];
                }
            });
        });
    };
    GamesStaticHttpAdapter.prototype.mergeOverrideWithDefaultConfig = function (defaultConfig, configOverride) {
        // Array should not be merged, but replaced instead
        var handleArrayMapping = function (defaultValue, overrideValue) {
            if (Array.isArray(defaultValue))
                return overrideValue;
        };
        // Default config with company override
        var mergedConfig = (0, lodash_1.mergeWith)(defaultConfig, configOverride, handleArrayMapping);
        var mappedProductName = this.options.productName.toLowerCase();
        if (this.options.keepStaticConfigStructure)
            return mergedConfig;
        var channelConfig;
        // Config per game
        var companyConfig = (0, lodash_1.omit)(mergedConfig, 'products');
        var products = mergedConfig.products;
        var gameConfig = products ? (0, lodash_1.omit)(products[mappedProductName], 'channels') : {};
        companyConfig = (0, lodash_1.merge)(companyConfig, gameConfig);
        if (this.options.channel) {
            // config per channel
            var gameSpecificConfig = mergedConfig.products && mergedConfig.products[mappedProductName];
            channelConfig = gameSpecificConfig && gameSpecificConfig.channels ? gameSpecificConfig.channels[(this.options.channel).toLowerCase()] : {};
            companyConfig = (0, lodash_1.mergeWith)(companyConfig, channelConfig, handleArrayMapping);
        }
        return companyConfig;
    };
    return GamesStaticHttpAdapter;
}(HttpAdapter_1.HttpAdapter));
exports.GamesStaticHttpAdapter = GamesStaticHttpAdapter;
//# sourceMappingURL=GamesStaticHttpAdapter.js.map